import React from 'react';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';
import { channelPluralize } from '@r1-frontend/shared/helpers/pluralize/predifined';
import { AccServiceBlock, AccServiceTitle, ServiceBlock, ServiceTitle } from '../styled';
import IncludesList from './includesList';
var channelText = getPluralize(channelPluralize);
var TvBlock = function (_a) {
    var isAccordion = _a.isAccordion, withBg = _a.withBg, isOpen = _a.isOpen, onToggle = _a.onToggle, totalChannels = _a.totalChannels, tvDescriptions = _a.tvDescriptions, openPopup = _a.openPopup;
    return (isAccordion && tvDescriptions.length
        ? <AccServiceBlock withBg={withBg} isClosed={!isOpen} defaultOpen={isOpen} open={isOpen} toggle={onToggle} data-test='acc-includes' title={<AccServiceTitle data-test='block-title'>
                    {totalChannels}&nbsp;{channelText(totalChannels)}
                </AccServiceTitle>}>
            <IncludesList tvDescriptions={tvDescriptions} openPopup={openPopup}/>
        </AccServiceBlock>
        : <ServiceBlock data-test='includes'>
            <ServiceTitle withBg={withBg} data-test='block-title'>
                {totalChannels}&nbsp;{channelText(totalChannels)}
            </ServiceTitle>
            {!!tvDescriptions.length && <IncludesList tvDescriptions={tvDescriptions} openPopup={openPopup}/>}
        </ServiceBlock>);
};
export default TvBlock;
